import { endpointDeclaration } from '@moojo/endpoints'
import { z } from 'zod'

/**
 * Beskar Portal Page API
 *
 * This endpoint returns a styled HTML page showcasing Beskar steel properties
 * and Mandalorian culture information.
 */
export const BeskarPortalPageRequest = z.record(z.string(), z.never())
export type BeskarPortalPageRequest = z.infer<typeof BeskarPortalPageRequest>

/**
 * This endpoint returns a raw HTTP response with HTML content.
 * The type definition uses `unknown` since the actual response is HTML, not JSON.
 */
export const BeskarPortalPageResponse = z.unknown()
export type BeskarPortalPageResponse = z.infer<typeof BeskarPortalPageResponse>

export const beskarPortalPageDeclaration = endpointDeclaration(BeskarPortalPageRequest, BeskarPortalPageResponse)
